import { Injectable } from "@angular/core";

interface Icon {
	icon: string;
	color?: string;
}

@Injectable()
export class MedicalIconService {
	private readonly iconMap: Record<string, Icon> = {
		blood_pressure: { icon: "fa fa-heartbeat", color: "rgb(176, 42, 89)" },
		heart_pulse: { icon: "fa fa-stethoscope" },
		["heart-rate"]: { icon: "fa fae-pulse", color: "rgb(176, 42, 89)" },
		diuresis: { icon: "fa fa-tint", color: "rgb(70, 135, 223)" },
		blood_glucose: { icon: "fa fa-tint", color: "rgb(242, 62, 62)" },
		spo2: { icon: "med-icon md-o2", color: "rgb(70, 135, 223)" },
		weight: { icon: "fa fa-balance-scale", color: "rgb(73, 42, 176)" },
		steps: { icon: "med-icon md-steps" },
		sleep: { icon: "fa fa-bed" },
		temperature: { icon: "fa fa-thermometer-full", color: "rgb(42, 176, 145)" },
		humidity: { icon: "med-icon md-humidity" },
		voc: { icon: "med-icon md-air_quality" },
		faeces: { icon: "fa fae fae-toilet", color: "rgb(244, 152, 66)" },
	};

	public getIcon(type: string, fallback?: string) {
		return this.iconMap[type].icon || fallback;
	}

	public getColor(type: string) {
		return this.iconMap[type].color;
	}
}
